import { useEffect, useState } from "react";
import { Icon } from "@iconify/react";

import {
  Dialog,
  IconButton,
  InputAdornment,
  ListItemIcon,
  MenuItem,
  TextField,
} from "@mui/material";

import CloseOutlined from "@mui/icons-material/CloseOutlined";
import "./AdditionalFilter.css";
import "../Components/Components.css";

const AdditionalFilter = ({ isOpen, setIsAdditionalFilterDialogShown }) => {
  const [name, setName] = useState("");
  const [ref, setRef] = useState("");
  const [type, setType] = useState("");
  const [isHelpdeskContact, setIsHelpdeskContact] = useState(true); // Check if contact is a helpdesk contact
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [fields, setFields] = useState(["new field"]);

  const resetFields = () => {
    setName("");
    setRef("");
    setType("");
    setIsHelpdeskContact(true);
    setFields(["new field"]);
  };

  // Get customer detail then map the data. This function only runs when editing
  useEffect(() => {
    resetFields();
  }, [isOpen]);

  const handleClose = () => {
    resetFields();
    setIsAdditionalFilterDialogShown(false);
  };

  const handleAddField = () =>
    setFields((current) => [...current, "new field"]);

  // const handleFieldChange = (value, index) => {
  //   let currentFields = [...fields];
  //   currentFields[index].value = value;
  //   setFields(currentFields);
  // };

  const handleRemoveField = (index) => {
    let currentFields = [...fields];
    currentFields.splice(index, 1);
    setFields(currentFields);
  };

  const renderFields = () => {
    let renderedFields = [];

    fields.forEach((field, index) => {
      renderedFields.push(
        <div className="item" key={index}>
          <TextField
            fullWidth
            label="Selections"
            placeholder="Customer Type"
            select
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="Customer">
              <ListItemIcon>
                <Icon icon="mdi:user" width="28" height="28" />
              </ListItemIcon>
              Customer
            </MenuItem>

            <MenuItem value="Non Customer">
              <ListItemIcon>
                <Icon icon="mdi:hand-extended" width="28" height="28" />
              </ListItemIcon>
              Non Customer
            </MenuItem>

            {/* jiva Requested */}
            <MenuItem value="R2">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              R2
            </MenuItem>
            <MenuItem value="R3">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              R3
            </MenuItem>
            <MenuItem value="Sahabat Jiva">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Sahabat Jiva
            </MenuItem>
            <MenuItem value="Jiva farmers - connected">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Jiva farmers - connected
            </MenuItem>
            <MenuItem value="Jiva farmers-not connected">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Jiva farmers-not connected
            </MenuItem>
            <MenuItem value="Non-Jiva Farmers">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Non-Jiva Farmers
            </MenuItem>
            <MenuItem value="Unknown Customer Type">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Unknown Customer Type
            </MenuItem>
          </TextField>

          <TextField
            fullWidth
            label="Equal"
            placeholder="Customer Type"
            select
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="Customer">
              <ListItemIcon>
                <Icon icon="mdi:user" width="28" height="28" />
              </ListItemIcon>
              Customer
            </MenuItem>

            <MenuItem value="Non Customer">
              <ListItemIcon>
                <Icon icon="mdi:hand-extended" width="28" height="28" />
              </ListItemIcon>
              Non Customer
            </MenuItem>

            {/* jiva Requested */}
            <MenuItem value="R2">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              R2
            </MenuItem>
            <MenuItem value="R3">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              R3
            </MenuItem>
            <MenuItem value="Sahabat Jiva">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Sahabat Jiva
            </MenuItem>
            <MenuItem value="Jiva farmers - connected">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Jiva farmers - connected
            </MenuItem>
            <MenuItem value="Jiva farmers-not connected">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Jiva farmers-not connected
            </MenuItem>
            <MenuItem value="Non-Jiva Farmers">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Non-Jiva Farmers
            </MenuItem>
            <MenuItem value="Unknown Customer Type">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Unknown Customer Type
            </MenuItem>
          </TextField>

          <TextField
            autoComplete="off"
            fullWidth
            label="Input"
            placeholder="Contact Name"
            value={name}
            InputProps={{
              endAdornment: (
                <InputAdornment
                  position="end"
                  sx={{ cursor: "pointer" }}
                  onClick={() => setName("")}
                >
                  <Icon icon="ph:x-bold" width="26" />
                </InputAdornment>
              ),
            }}
            onChange={(e) => setName(e.target.value)}
          />

          <TextField
            fullWidth
            label="AND"
            placeholder="Customer Type"
            select
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="Customer">
              <ListItemIcon>
                <Icon icon="mdi:user" width="28" height="28" />
              </ListItemIcon>
              Customer
            </MenuItem>

            <MenuItem value="Non Customer">
              <ListItemIcon>
                <Icon icon="mdi:hand-extended" width="28" height="28" />
              </ListItemIcon>
              Non Customer
            </MenuItem>
            {/* jiva Requested */}
            <MenuItem value="R2">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              R2
            </MenuItem>
            <MenuItem value="R3">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              R3
            </MenuItem>
            <MenuItem value="Sahabat Jiva">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Sahabat Jiva
            </MenuItem>
            <MenuItem value="Jiva farmers - connected">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Jiva farmers - connected
            </MenuItem>
            <MenuItem value="Jiva farmers-not connected">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Jiva farmers-not connected
            </MenuItem>
            <MenuItem value="Non-Jiva Farmers">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Non-Jiva Farmers
            </MenuItem>
            <MenuItem value="Unknown Customer Type">
              <ListItemIcon>
                <Icon icon="ic:round-star" width="28" height="28" />
              </ListItemIcon>
              Unknown Customer Type
            </MenuItem>
          </TextField>

          {fields.length > 1 && (
            <IconButton
              className="remove-field-button"
              onClick={() => handleRemoveField(index)}
            >
              <Icon
                icon="ic:sharp-remove-circle"
                color="#727272"
                width="30"
                height="30"
              />
            </IconButton>
          )}
        </div>
      );
    });

    return renderedFields;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog additional-filter"
      fullWidth
      maxWidth="lg"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <form method="post" onSubmit={handleSubmit}>
          <div className="dialog-content">
            <h2 className="title">Additional Filters</h2>

            <IconButton className="close-button" onClick={handleClose}>
              <CloseOutlined />
            </IconButton>

            <section className="form-inputs">
              {renderFields()}

              <button
                className="add-field"
                type="button"
                onClick={handleAddField}
              >
                <Icon
                  icon="icon-park-outline:list-add"
                  width="20"
                  height="20"
                />
                Add Field
              </button>
            </section>
          </div>

          <section className="buttons">
            <button className="cancel" type="button" onClick={handleClose}>
              Cancel
            </button>

            <button className="confirm" disabled={isSubmitting} type="submit">
              {/* {isSubmitting && <CircularProgress className="progress" />} */}
              Confirm
            </button>
          </section>
        </form>
      </div>
    </Dialog>
  );
};

export default AdditionalFilter;
